import Search from "@mui/icons-material/Search";
import Form from "react-bootstrap/Form";
import { useSearchParams } from "react-router-dom";
import { useDoctorsData } from "../../../providers/doctorsData";
import { useFilters } from "../../../providers/filters";
import { DatePickerComponent } from "../../Cards/DatePicker";
import { DropDownMenu } from "../../Modals/DropDownMenu";
import { ToggleButtons } from "../Buttons/ToggleButtons";
import { CircularProgress } from "@mui/material";

const ListFilters = () => {

  const { insurances, doctorsCount, specs, searching, revalidating } = useDoctorsData();
  const [searchParams, setSearchParams] = useSearchParams();
  const { resetFilters, searchInputValue, setSearchInputValue, setLocalModal, scrollToList, states } = useFilters();

  // Atualiza URL ao trocar especialidade
  const setSpecFilter = (spec: string) => {
    searchParams.set("spec", spec);
    searchParams.delete("page");  // reset paginação
    setSearchParams(searchParams);
  };

  // Atualiza URL ao trocar convênio
  const setHealthyInsuranceFilter = (insurance: string) => {
    searchParams.set("insurance", insurance.toLowerCase());
    searchParams.delete("page");  // reset paginação
    setSearchParams(searchParams);
  };

  const handleToggleButtons = (value: string) => {
    let scheduType = "";
    if (value === "Presencial") scheduType = "0";
    if (value === "Vídeo") scheduType = "1";

    if (searchParams.get("scheduType") === scheduType) {
      searchParams.delete("scheduType");
    } else {
      searchParams.set("scheduType", scheduType);
    }
    searchParams.delete("page");  // reset paginação
    setSearchParams(searchParams);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    scrollToList.current = true
    if (searchInputValue) {
      searchParams.set("search", searchInputValue);
    } else {
      searchParams.delete("search");
    }
    searchParams.delete("page");  // reset paginação
    setSearchParams(searchParams);
  };

  return (
    <div className="filtros-listagem py-2 mb-4">
      <div className="container">
        <div className="row g-2 align-items-end">
          <div className="col-12 col-lg-auto">
            <h3 className="mb-0 pe-2">
              <b className="text-primary fs-1 me-2">
                {searching ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  <>
                    {doctorsCount.length ? doctorsCount : "0"}
                  </>
                )}
              </b>
              <span >
                {Number(doctorsCount) === 1 ? "Profissional" : "Profissionais"}
              </span>
            </h3>
            {revalidating && (
              <span className="revalidating-badge" role="status">
                <span
                  className="spinner-border spinner-border-sm me-2"
                  aria-hidden="true"
                ></span>
                Atualizando lista…
              </span>
            )}
          </div>
          <div className="col">
            <div className="row g-2 align-items-center">
              <div className="col-12 col-lg">
                {/* FORM SUBMIT */}
                <form
                  className="w-100 rounded-pill d-flex position-relative"
                  onSubmit={handleSubmit}
                >
                  <label htmlFor="search-list">
                    <Search
                      className="position-absolute start-0 ms-3 top-50 translate-middle-y"
                      sx={{ color: "action.active" }}
                    />
                  </label>
                  <Form.Control
                    type="text"
                    id="search-list"
                    name="search"
                    placeholder="Condição, procedimento ou nome do médico..."
                    className="rounded-pill px-5"
                    onChange={(e) => setSearchInputValue(e.target.value)}
                    value={searchInputValue}
                  />
                  <button
                    type="submit"
                    className="btn btn-sm btn-primary position-absolute end-0 top-50 translate-middle-y py-1 px-2 me-1"
                    disabled={searching}
                  >
                    <i className="las lh-1 la-search"></i>
                  </button>
                </form>
              </div>

              <div className="col col-auto">
                <DatePickerComponent theme="dark" />
              </div>
            </div>
          </div>
        </div>
        <hr className="my-2" />
        <div className="row g-2">
          <div className="col-12 col-md-auto">
            <p className="ms-2 mb-0 lh-1 py-2">Filtrar:</p>
          </div>
          <div className="col">
            <div className="row align-items-center g-2">
              <div className="col col-auto">
                <button
                  onClick={() => {
                    setLocalModal(true);
                  }}
                  disabled={states.length <= 0}
                  className="btn btn-btn btn-outline-secondary d-flex-align-items-center"
                >
                  <i className="las la-map-marker-alt me-2 opacity-50" />
                  <span>
                    {searchParams.get("location")?.toLowerCase() ?? "Locais"}
                  </span>
                </button>
              </div>

              <div className="col col-auto">
                <DropDownMenu
                  disabled={true}
                  label="Especialidade"
                  itensList={specs}
                  value={searchParams.get("spec") ?? ""}
                  setValue={setSpecFilter}
                  theme="dark"
                  icon="las la-stethoscope me-2 opacity-50"
                />
              </div>

              <div className="col col-auto">
                <DropDownMenu
                  label="Convênio"
                  itensList={insurances}
                  value={searchParams.get("insurance") ?? ""}
                  setValue={setHealthyInsuranceFilter}
                  theme="dark"
                  icon="las la-briefcase me-2 opacity-50"
                />
              </div>

              <div className="col col-auto">
                <ToggleButtons
                  value={
                    searchParams.get("scheduType") === "0"
                      ? ["Presencial"]
                      : searchParams.get("scheduType") === "1"
                        ? ["Vídeo"]
                        : []
                  }
                  setValue={handleToggleButtons}
                  theme="dark"
                  firstButtonName="Vídeo"
                  firstButtonIcon="las la-video me-2 opacity-50"
                  secondButtonName="Presencial"
                  secondButtonIcon="las la-hospital me-2 opacity-50"
                />
              </div>
              {Array.from(searchParams).length > 0 && (
                <div className="col col-auto">
                  <button
                    onClick={() => {
                      setSearchInputValue("");
                      resetFilters();
                      setSearchParams({});
                    }}
                    className="btn btn-outline-danger"
                  >
                    <span>Limpar Filtros</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListFilters;
